// TODO: When manifest and confluence backend is updated we need to update the extension keys
// Please make sure to do a search for all the extension keys and update them
export var ExtensionKeys = /*#__PURE__*/function (ExtensionKeys) {
  ExtensionKeys["AISummaryExtension"] = "ai-summary-block:aiSummaryExtension";
  ExtensionKeys["AISummaryBodiedExtension"] = "ai-summary-block:aiSummaryBodiedExtension";
  ExtensionKeys["AIActionItemsExtension"] = "ai-action-items-block:aiActionItemsExtension";
  ExtensionKeys["AIActionItemsBodiedExtension"] = "ai-action-items-block:aiActionItemsBodiedExtension";
  return ExtensionKeys;
}({});